export default [
    {
        value: "PeriodoNacional",
        text: "Período nacional"
    },
    {
        value: "PeriodoInternacional",
        text: "Período internacional"
    },
    {
        value: "AnaisEventoNacional",
        text: "Anais de evento nacional"
    },
    {
        value: "AnaisEventoInternacional",
        text: "Anais de evento internacional"
    },
]